module.exports = __webpack_public_path__ + "components/carousel-nearby-mountains/static/generic-bg--6-fbdef995b4f24e1256e7f64f8d0d456d.jpg";